import { alpha } from '@mui/material/styles';

import { StarIcon } from './customIcons';

import type { OverWritable } from '../../@types/settings';

// ----------------------------------------------------------------------

const ICON_SMALL = {
  width: 20,
  height: 20,
};
const ICON_LARGE = {
  width: 28,
  height: 28,
};

export const rating: OverWritable = {
  MuiRating: {
    defaultProps: {
      emptyIcon: <StarIcon />,
      icon: <StarIcon />,
    },

    styleOverrides: {
      root: {
        '&.Mui-disabled': {
          opacity: 0.48,
        },
      },
      iconEmpty: ({ theme }) => ({
        color: alpha(theme.palette.grey[500], 0.48),
      }),
      sizeSmall: { '& svg': { ...ICON_SMALL } },
      sizeLarge: { '& svg': { ...ICON_LARGE } },
    },
  },
};
